<template>
  <div id="registro">
    <div v-if="loading" id="preloader">
      <div class="lds-circle"><div></div></div>
    </div>
    <div v-else>
      <!-- Page Content -->
      <div class="page-content">
        <!-- Banner -->
        <div class="banner-wrapper shape-1">
          <div class="container inner-wrapper">
            <img src="assets/images/logo/logo-sm.png" class="mx-auto" />
            <h3 class="dz-title mt-2">
              Hola {{ usuario.nombres }}, bienvenido a Reddy
            </h3>
            <p class="mb-0">Actualiza tus datos para continuar</p>
          </div>
        </div>
        <!-- Banner End -->
        <transition appear name="slide-fade">
          <div class="container">
            <div class="account-area">
              <form class="basic-form" v-on:submit.prevent="set_registro">
                <div class="input-group">
                  <input
                    v-model="usuario.nombres"
                    type="text"
                    placeholder="Nombres"
                    class="form-control"
                  />
                </div>
                <div class="input-group">
                  <input
                    v-model="usuario.apellidos"
                    type="text"
                    placeholder="Apellidos"
                    class="form-control"
                  />
                </div>
                <div class="input-group">
                  <input
                    v-model="usuario.celular"
                    type="text"
                    placeholder="Número de teléfono móvil"
                    class="form-control"
                  />
                </div>
                <div class="input-group">
                  <input
                    v-model="usuario.fecha_nacimiento"
                    type="date"
                    class="form-control"
                  />
                </div>
                <h6 class="mt-3 mb-2">Crea tu contraseña de acceso</h6>
                <div class="form-group mb-3">
                  <div class="">
                    <div class="form-input">
                      <input
                        v-model="nuevo_password"
                        type="password"
                        placeholder="Nueva contraseña"
                        id="dz-password_1"
                        class="form-control input_pass be-0"
                      />
                      <span
                        v-on:click="toggle_input_pass(1)"
                        class="input_icon_pass"
                      >
                        <i class="fa fa-eye"></i>
                      </span>
                    </div>
                  </div>
                </div>
                <div class="form-group mb-3">
                  <div class="">
                    <div class="form-input">
                      <input
                        v-model="nuevo_password_confirm"
                        type="password"
                        placeholder="Confirma tu nueva contraseña"
                        id="dz-password_2"
                        class="form-control input_pass be-0"
                      />
                      <span
                        v-on:click="toggle_input_pass(2)"
                        class="input_icon_pass"
                      >
                        <i class="fa fa-eye"></i>
                      </span>
                    </div>
                  </div>
                </div>
                <div class="input-group">
                  <button
                    type="submit"
                    class="btn mt-2 btn-primary w-100 btn-rounded"
                  >
                    Siguiente <i class="fa fa-chevron-right"></i>
                  </button>
                </div>
              </form>
            </div>
          </div>
        </transition>
      </div>
      <!-- Page Content End -->
      <!-- Footer -->
      <!-- <footer class="footer fixed">
        <div class="container">
          <router-link
            to="/auth"
            class="btn btn-primary light btn-rounded text-primary d-block"
            >Iniciar sesión</router-link
          >
        </div>
      </footer> -->
      <!-- Footer End -->
    </div>
  </div>
</template>
<script>
import axios from "axios";
export default {
  name: "Registro",
  metaInfo: {
    title: "Crea tu cuenta - Reddy App",
  },
  data() {
    return {
      loading: true,
      token: null,
      usuario: [],
      nuevo_password: null,
      nuevo_password_confirm: null,
    };
  },
  created: function () {
    this.token = this.$route.params.token;
    this.get_valida_token();
  },
  methods: {
    get_valida_token: function () {
      if (this.token == null || this.token == "") {
        return false;
      }
      const headers = {
        "Content-Type": "application/json",
        "x-api-key": this.$api_key,
      };
      let config = {
        headers: headers,
        params: {
          token: this.token,
        },
      };
      const vm = this;
      axios
        .get(this.$base_url + "auth/valida_token_registro", config, {
          headers: headers,
        })
        .then((response) => {
          if (!response.data.status) {
            vm.$notify({
              type: "error",
              group: "foo",
              title: "<i class='fa fa-exclamation-circle'></i> Ups!",
              text: response.data.message,
            });
            this.$router.push("/auth");
          }
          this.usuario = response.data.data;
          this.loading = false;
        })
        .catch((error) =>
          vm.$notify({
            type: "error",
            group: "foo",
            title: "<i class='fa fa-exclamation-circle'></i> Ups!",
            text: error,
          })
        )
        .finally();
    },
    set_registro: function () {
      if (
        this.usuario.nombres == null ||
        this.usuario.nombres.trim().length == 0
      ) {
        this.$notify({
          type: "error",
          group: "foo",
          title: "<i class='fa fa-exclamation-circle'></i> Ups!",
          text: "Digita tu nombre",
        });
        return false;
      }
      if (
        this.usuario.apellidos == null ||
        this.usuario.apellidos.trim().length == 0
      ) {
        this.$notify({
          type: "error",
          group: "foo",
          title: "<i class='fa fa-exclamation-circle'></i> Ups!",
          text: "Digita tu apellido",
        });
        return false;
      }
      if (
        this.nuevo_password == null ||
        this.nuevo_password.trim().length == 0
      ) {
        this.$notify({
          type: "error",
          group: "foo",
          title: "<i class='fa fa-exclamation-circle'></i> Ups!",
          text: "Digita tu nueva contraseña",
        });
        return false;
      }
      if (
        this.nuevo_password_confirm == null ||
        this.nuevo_password_confirm.trim().length == 0
      ) {
        this.$notify({
          type: "error",
          group: "foo",
          title: "<i class='fa fa-exclamation-circle'></i> Ups!",
          text: "Confirma tu nueva contraseña",
        });
        return false;
      }
      if (this.nuevo_password_confirm != this.nuevo_password) {
        this.$notify({
          type: "error",
          group: "foo",
          title: "<i class='fa fa-exclamation-circle'></i> Ups!",
          text: "La contraseña digitada no coincide con la confirmación",
        });
        return false;
      }
      const headers = {
        "Content-Type": "application/json",
        "x-api-key": this.$api_key,
      };
      let params = {
        token: this.token,
        usuario: this.usuario,
        password: this.nuevo_password,
      };
      const vm = this;
      axios
        .post(this.$base_url + "auth/set_registro", params, {
          headers: headers,
        })
        .then((response) => {
          if (!response.data.status) {
            vm.$notify({
              type: "error",
              group: "foo",
              title: "<i class='fa fa-exclamation-circle'></i> Ups!",
              text: response.data.message,
            });
            return false;
          }
          vm.$notify({
            type: "success",
            group: "foo",
            title: "<i class='fa fa-check-circle'></i> Muy bien",
            text: response.data.message,
          });
          vm.$router.push("/auth");
        })
        .catch((error) =>
          vm.$notify({
            type: "error",
            group: "foo",
            title: "<i class='fa fa-exclamation-circle'></i> Ups!!",
            text: error,
          })
        )
        .finally();
    },
    toggle_input_pass: function (who) {
      if (document.getElementById("dz-password_" + who).type == "password") {
        document.getElementById("dz-password_" + who).type = "text";
      } else {
        document.getElementById("dz-password_" + who).type = "password";
      }
    },
  },
};
</script>